import {NgIf} from '@angular/common';
import {Component, computed, effect, input, output} from '@angular/core';
import {Campaign, SwipeableComponent} from 'shared-lib';
import {LimitedOfferDetailsComponent} from "./limited-offer-details/limited-offer-details.component";

@Component({
  selector: 'app-limited-offers-carousel',
  templateUrl: './limited-offers-carousel.component.html',
  styleUrls: ['./limited-offers-carousel.component.scss'],
  imports: [
    NgIf,
    LimitedOfferDetailsComponent,
    SwipeableComponent
  ]
})
export class LimitedOffersCarouselComponent {
  campaigns = input.required<Campaign[]>();
  selectedCampaign = input<Campaign>();
  selectedCampaignChange = output<Campaign>();

  componentId = `carousel-id`;

  itemMap = computed<Map<number, Campaign>>(() =>
    this.createSliderGroups()
  );
  itemKeys = computed<number[]>(() => {
    return Array.from(this.itemMap().keys());
  });

  private _ = effect(() => {
    this.itemMap().forEach((value, key) => {
      if (this.selectedCampaign() && value.id === this.selectedCampaign()!.id) {
        this.scrollToElement(key);
      }
    });
  });
  private currentPage: number = 0;

  navToNext(): void {
    if (this.currentPage < this.campaigns().length - 1) {
      this.currentPage++;
      this.navigateToGroup(this.currentPage);
      this.selectedCampaignChange.emit(this.campaigns()[this.currentPage]);
    }
  }

  navToPrev(): void {
    if (this.currentPage >= 1) {
      this.currentPage--;
      this.navigateToGroup(this.currentPage);
      this.selectedCampaignChange.emit(this.campaigns()[this.currentPage]);
    }
  }

  private navigateToGroup(groupId: number): void {
    const sliderGroup: Element | null = document.querySelector(
      `#${this.componentId}-group-${groupId}`
    );

    sliderGroup?.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
    });
  }

  private createSliderGroups(): Map<number, Campaign> {
    const itemMap = new Map<number, Campaign>();
    let index = 0;
    this.campaigns().forEach((campaign: Campaign) => {
      itemMap.set(index++, campaign);
    });
    return itemMap;
  }

  private scrollToElement(index: number): void {
    if (this.currentPage !== index) {
      this.currentPage = index;
      this.navigateToGroup(this.currentPage);
    }
  }
}
